import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { SecondAds,    FirstAds , MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";
const TITLE = "حاسبة نسبة الكوليسترول";
const DESCRIPTION =
  "حاسبة الكوليسترول وصحة القلب: حلّل نسبة الكوليسترول الكلي، LDL، HDL، والدهون الثلاثية لتقييم خطر أمراض القلب! أدخل نتائج فحص الدم للحصول على تقرير مفصل مع تفسير طبي للنسب المثالية - أداة ضرورية للمراقبة الصحية الوقائية.";
const KEYWORDS =
  "حساب نسبة الكوليسترول، كوليسترول، قلب، صحة قلبية، صحة، نسبة، حاسبة نسبة الكوليسترول";
const OG_URL =
  "https://do-calculate.com/calculator/ar/cholesterol-ratio-calculator/";
function CholesterolRatioCalculator() {
  const [hdl, setHdl] = useState(0);
  const [ldl, setLdl] = useState(0);
  const [tg, setTg] = useState(0);
  const [result, setResult] = useState();
  const [error, setError] = useState("");
  const handleCalculate = () => {
    try {
      const hdlValue = parseFloat(hdl);
      const ldlValue = parseFloat(ldl);
      const tgValue = parseFloat(tg);
      const totalCholesterol = hdlValue + ldlValue + 0.2 * tgValue;
      const cholesterolHdlRatio = totalCholesterol / hdlValue;
      const ldlHdlRatio = ldlValue / hdlValue;
      let ldlHdlCategory = "";
      if (ldlHdlRatio < 2) {
        ldlHdlCategory = "مثالي";
      } else if (ldlHdlRatio < 5) {
        ldlHdlCategory = "جيد";
      } else {
        ldlHdlCategory = "مرتفع جدًا";
      }
      const tgHdlRatio = tgValue / hdlValue;
      let tgHdlCategory = "";
      if (tgHdlRatio <= 0.87) {
        tgHdlCategory = "مثالي";
      } else if (tgHdlRatio <= 2.62) {
        tgHdlCategory = "مرتفع";
      } else {
        tgHdlCategory = "مرتفع جدًا";
      }
      setResult({
        totalCholesterol: totalCholesterol.toFixed(2),
        ldlHdlRatio: ldlHdlRatio.toFixed(2),
        ldlHdlCategory,
        tgHdlRatio: tgHdlRatio.toFixed(2),
        tgHdlCategory,
        cholesterolHdlRatio: cholesterolHdlRatio.toFixed(2),
      });
    } catch (error) {
      setError(error.message);
    }
  };
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>هذه الحاسبة تساعدك في معرفة نسبة الكوليسترول وصحة القلب.</p>
                <p>
                  فهم مستوى الكوليسترول هو الخطوة الأولى نحو قلب صحي. تتيح لك
                  هذه الحاسبة فهم معنى نتائج فحوصات الكوليسترول. بإدخال قيمك،
                  ستحصل على تفسير مبسط لنسبة الكوليسترول الكلي، وLDL، وHDL، وTG.
                  استخدم هذه المعلومات لتتخذ قرارات مستنيرة بشأن صحتك.
                </p>
                <p>
                  اهتم بصحتك القلبية! هذه الحاسبة تساعدك في تقدير صحة قلبك من
                  خلال حساب نسبة الكوليسترول المختلفة. بإدخال قيم الكوليسترول
                  الكلي، وLDL (الكوليسترول الضار)، وHDL (الكوليسترول النافع)،
                  وTG (الدهون الثلاثية)، ستحصل على فكرة عن مدى توازن مستوى
                  الكوليسترول لديك.
                </p>
                <p>
                  <b>
                    هام: يجب التأكيد على أن هذه الحاسبة هي أداة مساعدة فقط، ولا
                    يجب الاعتماد عليها كتشخيص طبي. في حال كان لديك أي مخاوف بشأن
                    صحتك، يجب عليك استشارة طبيبك.
                  </b>
                </p>
                <p>
                  تم تطوير الحاسبة بالاعتماد على{" "}
                  <a
                    href="https://www.ncbi.nlm.nih.gov/pmc/articles/PMC2747394/"
                    rel="nofollow"
                  >
                    المكتبة الدولية للدواء
                  </a>
                </p>
                <hr />
              </div>
              <br />
            </div>
            <MobileUnderCalAds/>
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <div dir="rtl">
                  <div>
                    <hr />
                    <div className="form-group">
                      <label className="form-label ms-2" htmlFor="hdl">
                        HDL - البروتين الدهني عالي الكثافة (الكوليسترول الجيد)
                      </label>
                      <input
                        id="hdl"
                        type="number"
                        value={hdl}
                        onChange={(e) => setHdl(e.target.value)}
                        placeholder="أدخل مستوى HDL"
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <div className="form-group">
                      <label className="form-label ms-2" htmlFor="ldl">
                        LDL - البروتين الدهني منخفض الكثافة (الكوليسترول الضار)
                      </label>
                      <input
                        id="ldl"
                        type="number"
                        value={ldl}
                        onChange={(e) => setLdl(e.target.value)}
                        placeholder="أدخل مستوى LDL"
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <div className="form-group">
                      <label className="form-label ms-2" htmlFor="tg">
                        TG - الدهون الثلاثية
                      </label>
                      <input
                        id="tg"
                        type="number"
                        value={tg}
                        onChange={(e) => setTg(e.target.value)}
                        placeholder="أدخل مستوى TG"
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px", marginLeft: "10px" }}
                      onClick={handleCalculate}
                    >
                      احسب                    </button>
                  </div>
                  <br />
                  { error !== "" && (
                    <p className="p-3 mb-2 bg-warning text-black">
                      خطأ: {error}
                    </p>
                  )}
                  {result &&  (
                    <div className="p-3 mb-2 bg-success text-white">
                      <h4>النتيجة:</h4>
                      <p className="text-white">
                        إجمالي الكوليسترول: {result.totalCholesterol}
                      </p>
                      <p className="text-white">
                        نسبة الكوليسترول / HDL هي: {result.cholesterolHdlRatio}
                      </p>
                      <p className="text-white">
                        نسبة LDL/HDL هي: {result.ldlHdlRatio} -{" "}
                        {result.ldlHdlCategory}
                      </p>
                      <p className="text-white">
                        نسبة TG/HDL هي: {result.tgHdlRatio} -{" "}
                        {result.tgHdlCategory}
                      </p>
                    </div>
                  )}
                  <hr />
                </div>
              </div>
            </div>
            <hr />            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">مزيد من التفاصيل</div>
              <div className="info-section-body">
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>نسب الكوليسترول</h2>
                  </u>
                  <p>
                    الكوليسترول هو مادة دهنية ضرورية لوظائف الجسم المختلفة. مع
                    ذلك، فإن زيادته قد تسبب مشاكل صحية.
                  </p>
                </div>
                <hr />
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>فهم القيم</h2>
                  </u>
                  <p>
                    القيم المنخفضة من LDL والمستويات العالية من HDL تساعد في
                    تقليل خطر الإصابة بأمراض القلب. ومن المهم متابعة نسبة TG/HDL
                    أيضًا لأنها مؤشر على صحة القلب.
                  </p>
                  <p>
                    <b>نسبة HDL (الكوليسترول الجيد):</b>
                  </p>
                  <ul>
                    <li>للرجال: أعلى من 40 ملغ/ديسيلتر</li>
                    <li>للنساء: أعلى من 50 ملغ/ديسيلتر</li>
                  </ul>
                  <p>
                    <b>نسبة LDL (الكوليسترول الضار):</b>
                  </p>
                  <ul>
                    <li>مستوى مثالي: أقل من 100 ملغ/ديسيلتر</li>
                    <li>مستوى مرتفع: بين 130-159 ملغ/ديسيلتر</li>
                    <li>مرتفع جدًا: أعلى من 160 ملغ/ديسيلتر</li>
                  </ul>
                  <p>
                    <b>نسبة TG (الدهون الثلاثية):</b>
                  </p>
                  <ul>
                    <li>مستوى طبيعي: أقل من 150 ملغ/ديسيلتر</li>
                    <li>مستوى مرتفع: بين 200-499 ملغ/ديسيلتر</li>
                    <li>مرتفع جدًا: أعلى من 500 ملغ/ديسيلتر</li>
                  </ul>
                </div>
                <hr />
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      كيفية تحسين نسب الكوليسترول
                    </h2>
                  </u>
                  <p>
                    تناول الأطعمة الغنية بالألياف، وممارسة الرياضة، وتجنب الدهون
                    المشبعة يمكن أن يساعد في تحسين نسب الكوليسترول في جسمك.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default CholesterolRatioCalculator;
